import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { useCart } from '../../contexts/CartContext';

/**
 * FloatingCartButton - Sticky cart button that appears at bottom of screen
 * כפתור עגלה צף בתחתית המסך
 */
const FloatingCartButton = () => {
  const { toggleCart, getItemCount, getTotal, getCartSummary } = useCart();
  
  const itemCount = getItemCount();
  const summary = getCartSummary();
  const total = summary.total || 0;

  // Don't show if cart is empty
  if (itemCount === 0) return null;

  return (
    <>
      {/* Mobile - Full Width Bottom */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 p-4 bg-gradient-to-t from-white via-white to-transparent">
        <div className="max-w-md mx-auto">
          <button
            onClick={toggleCart}
            className="w-full bg-primary-600 hover:bg-primary-700 text-white px-6 py-4 rounded-xl shadow-2xl flex items-center justify-between transition-all active:scale-[0.98]"
          >
            <div className="flex items-center gap-3">
              <div className="relative">
                <ShoppingCartIcon className="h-6 w-6" />
                {itemCount > 0 && (
                  <span className="absolute -top-2 -right-2 h-5 w-5 rounded-full bg-red-500 flex items-center justify-center text-xs font-bold text-white">
                    {itemCount}
                  </span>
                )}
              </div>
              <div className="text-right">
                <div className="font-bold text-lg">
                  {itemCount} פריטים
                </div>
                <div className="text-sm opacity-90">
                  לחץ לצפייה
                </div>
              </div>
            </div>
            <div className="text-left">
              <div className="font-bold text-2xl">
                ₪{total.toFixed(2)}
              </div>
              <div className="text-xs opacity-90">
                סה"כ
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* Desktop - Compact Bottom Right */}
      <div className="hidden lg:block fixed bottom-6 right-6 z-40">
        <button
          onClick={toggleCart}
          className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 transition-all hover:shadow-xl hover:scale-105 active:scale-95"
        >
          <div className="relative">
            <ShoppingCartIcon className="h-6 w-6" />
            {itemCount > 0 && (
              <span className="absolute -top-2 -right-2 h-5 w-5 rounded-full bg-red-500 flex items-center justify-center text-xs font-bold text-white">
                {itemCount}
              </span>
            )}
          </div>
          <div className="text-right">
            <div className="font-bold">
              {itemCount} פריטים
            </div>
            <div className="text-sm opacity-90">
              ₪{total.toFixed(2)}
            </div>
          </div>
          <div className="text-lg font-bold">
            →
          </div>
        </button>
      </div>
    </>
  );
};

export default FloatingCartButton;

